


function capitalize(str) {
    if (typeof str !== 'string') return '';  // Check if input is a string
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }


export default capitalize;